export const excludedCustomAttributeId = [
  2225, 2372, 2384,
  2200, 2214, 2220, 2234, 2248, 2260, 2265, 2266, 2267, 2277, 2278, 2279, 2292,
  2294, 2295, 2304, 2306, 2307, 2320, 2325, 2333, 2341, 2351, 2360, 2373, 2385,
  2387, 2393, 2394, 2395, 2408, 2409, 2422, 2423, 2436, 2437, 2438, 2451, 2452,
  2459, 2460, 2471, 2472, 2473, 2484, 2485, 2498, 2499, 2500, 2511, 2512, 2513,
  2526, 2527, 2538, 2539, 2552, 2553, 2554, 2565, 2566, 2567, 2581, 2582, 2583,
  2585, 2586, 2591, 2592, 2593, 2605, 2606, 2607, 2619, 2620, 2621, 2633, 2634,
  2635, 2661, 2662, 2663, 2675, 2676, 2689, 2690, 2691, 2702, 2703, 2704, 2716,
  2717, 2718, 2730, 2731, 2732, 2758, 2759, 2760, 2772, 2773, 2774, 2786, 2787,
  2788, 2800, 2801, 2802, 2814, 2815, 2816, 2828, 2829, 2830, 2842, 2843, 2844,
  2856, 2857, 2858, 2870, 2871, 2872, 2884, 2885, 2886, 2898, 2899, 2900, 2912,
  2913, 2914, 2940, 2941, 2942, 2954, 2955, 2956, 2968, 2969, 2970, 2982, 2983,
  2984, 2996, 2997, 2998, 3010, 3011, 3012, 3024, 3025, 3026, 3038, 3039, 3040,
  3052, 3053, 3054, 3066, 3067, 3068, 3080, 3081, 3082, 3094, 3095, 3096, 3108,
  3109, 3110, 3122, 3123, 3124, 3150, 3151, 3152, 3164, 3165, 3166, 3178, 3179,
  3180, 3192, 3193, 3194, 3209, 3212, 3213, 3214, 3215, 3216, 2268, 2282, 2296,
  2310, 2342, 2352, 2475, 2488, 2502, 2516, 2529, 2542, 2556, 2570, 2594, 2608,
  2622, 2636, 2664, 2679, 2693, 2705, 2719, 2733, 2761, 2775, 2789, 2803, 2817,
  2831, 2845, 2859, 2873, 2887, 2901, 2915, 2943, 2957, 2971, 2985, 2999, 3013,
  3027, 3041, 3055, 3069, 3083, 3097, 3111, 3125, 3153, 3167, 3181, 3195,
];
